import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import cx from "classnames";
import moment from 'moment';

import { CMS_URL } from "../../constants";

import "./CouponDetail.scss";

const CouponDetail = ({ detail, canApply, onApply, appliedCouponCode, errorMap }) => {
  if (isEmpty(detail)) {
    return <div className="couponDetailContainer" />;
  }

  const renderMultiLine = (multiLineObject) =>
    multiLineObject.split(/\n|\\n/).map((line, index) => {
      const firstChar = line[0];
      const addBullet = firstChar === "•";
      const addNumberedBullet = /\d/.test(firstChar);
      let lineContent = line;

      if (addBullet) {
        lineContent = line.slice(1, line.length);
      } else if (addNumberedBullet) {
        lineContent = line.replace(")", ".");
      }
      return (
        <div
          key={index}
          className={cx("descrtiption", {
            bullet: addBullet,
          })}
        >
          {lineContent}
        </div>
      );
    });

  const content = [
    { heading: "Eligibility", data: detail.detail.eligibilty },
    { heading: "How do you get it?", data: detail.detail.howToGet },
    {
      heading: "Conditions in case of cancellation",
      data: detail.detail.cancellationPolicy,
    },
    {
      heading: "Other terms and condition",
      data: detail.detail.termsAndConditions,
    },
  ];

  return (
    <div className="couponDetailContainer">
      <div className="title">{detail.title || "N/A"}</div>
      {!!detail.promoCode && (
        <div className="codeContainer">
          <span>{detail.promoCode}</span>
          <a
            target="_blank"
            href={`${CMS_URL}/coupon/search?q=${detail.promoCode}`}
          >
            Know More
          </a>
          {(canApply && !errorMap[detail.promoCode]) && !detail.isExpired &&
            (appliedCouponCode === detail.promoCode ? (
              <div>Applied</div>
            ) : (
              <div className="apply" onClick={() => onApply(detail)}>
                Apply
              </div>
            ))}
        </div>
      )}
      <div className="dashed" />
      <div className="benefits">
        <div className="title">Benefits</div>
        <p className="descrtiption">{detail.shortDescription || "N/A"}</p>
      </div>
      {content.map(({ heading, data }) => (
        <div key={heading}>
          <div className="dashed" />
          <div className="rules">
            <div className="title">{heading}</div>
            {!!data ? renderMultiLine(data) : "N/A"}
          </div>
        </div>
      ))}
      <div className="dashed" />
      <div className="expiryApplication">
        <div className="expiry">
          <span className="title">Expiry</span>
          <br />
          <span className="descrtiption">{moment(detail.expireAt).format('DD/MM/YYYY hh:mm A')}</span>
        </div>
        {/* <div className="application">
          <span className="title">Application</span>
          <br />
          <span className="descrtiption">{"Manual"}</span>
        </div> */}
      </div>
    </div>
  );
};

CouponDetail.propTypes = {
  detail: PropTypes.object,
  canApply: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  appliedCouponCode: PropTypes.string,
  errorMap: PropTypes.object.isRequired,
};

CouponDetail.defaultProps = {
  detail: {},
  canApply: false,
  appliedCouponCode: "",
};

export default CouponDetail;
